import React from 'react';
import { Link } from 'react-router-dom';
import '../NotFound.css'; // We'll create this CSS file

const NotFound = () => {
  return (
    <div className="modern-not-found">
      <div className="not-found-container">
        {/* Animated Background Elements */}
        <div className="bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>

        {/* Main Content */}
        <div className="not-found-content">
          {/* Animated 404 Number */}
          <div className="error-number">
            <span className="digit">4</span>
            <div className="planet">
              <div className="crater"></div>
              <div className="crater"></div>
              <div className="crater"></div>
            </div>
            <span className="digit">4</span>
          </div>

          {/* Message Section */}
          <div className="message-section">
            <h1 className="title">Page Lost in Space</h1>
            <p className="description">
              Oops! The page you're looking for seems to have drifted off into the digital cosmos. 
              Don't worry, even the best explorers sometimes get lost.
            </p>
            
            {/* Features Grid */}
            <div className="suggestions">
              <div className="suggestion-item">
                <div className="suggestion-icon">🔍</div>
                <span>Check the URL for typos</span>
              </div>
              <div className="suggestion-item">
                <div className="suggestion-icon">🏠</div>
                <span>Return to home base</span>
              </div>
              <div className="suggestion-item">
                <div className="suggestion-icon">📧</div>
                <span>Contact support if lost</span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="action-buttons">
            <Link to="/dashboard" className="primary-btn">
              <span className="btn-icon">🚀</span>
              Back to Dashboard
            </Link>
            <Link to="/" className="secondary-btn">
              <span className="btn-icon">🏠</span>
              Go Home
            </Link>
          </div>

          {/* Floating Astronaut */}
          <div className="floating-astronaut">
            <div className="astronaut">
              <div className="helmet">
                <div className="visor"></div>
              </div>
              <div className="body"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;